// src/constants/maintenanceCategories.js
export const MAINTENANCE_CATEGORIES = [
    "Plumbing & Water Leakage",
    "Electrical Issue",
    "Elevator / Lift Problem",
    "Housekeeping / Cleanliness",
    "Security / CCTV / Access Control",
    "Parking Issue",
    "Common Area Maintenance (Garden, Gym, Clubhouse, Pool)",
    "Pest Control",
    "Garbage / Waste Management",
    "Noise Complaint",
    "Structural (Cracks, Ceiling Leakage, Painting)",
    "Fire Safety Equipment",
    "Power Backup / Generator",
    "Intercom / Telephone",
    "Other",
  ];
  
  export const MAINTENANCE_STATUSES = ["Reported", "Acknowledged", "In Progress", "Resolved"];